import IconClose from "@9amhealth/shared/icons/IconClose";
import { useBlocNext } from "@blac/react";
import styled from "@emotion/styled";
import { FC } from "react";
import Translate from "src/ui/components/Translate/Translate";
import NotificationCardCubit from "./NotificationCardCubit";

const CloseButton = styled.button`
  position: absolute;
  width: 2.75rem;
  height: 2.75rem;
  right: 0;
  top: 0;

  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &::before {
    content: "";
    position: absolute;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 200px;
    background: rgba(33, 33, 33, 0.16);
    backdrop-filter: blur(6px);
    transition: background 0.2s ease;
  }

  &:hover {
    &::before {
      background: rgba(33, 33, 33, 0.24);
    }
  }

  &:focus-visible {
    outline: 2px solid var(--color-blue);
    outline-offset: 2px;
  }

  svg {
    position: relative;
    z-index: 1;
    color: white;
    scale: 0.5;
  }
`;

const Card = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 0.95fr auto;
  background: var(--color-cream-darker);
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid rgba(170, 167, 160, 0.5);
  margin-bottom: 2rem;
  overflow: hidden;
`;

const Content = styled.div`
  flex: 1;
`;

const ImageContainer = styled.div`
  width: 4rem;
  height: 4em;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &[data-custom="true"] {
    width: 6rem;
    height: 6em;
    margin: -1.75rem -2rem 0 0;
  }
`;

const VariantImage: FC<{
  variantImage: string;
  variantImageIsWide: boolean;
}> = ({ variantImage, variantImageIsWide }) => {
  return (
    <ImageContainer data-custom={variantImageIsWide}>
      <img src={variantImage} alt="" aria-hidden="true" />
    </ImageContainer>
  );
};

const NotificationCard: FC = () => {
  const [
    { variant, variantImage, variantImageIsWide, isVisible },
    { dismiss }
  ] = useBlocNext(NotificationCardCubit);

  if (!isVisible || !variant || !variantImage) {
    return null;
  }

  return (
    <Card
      role="article"
      aria-labelledby="notification.card.title"
      aria-describedby="notification.card.description"
    >
      <CloseButton
        onClick={dismiss}
        aria-label="notification.card.dismiss"
        type="button"
      >
        <IconClose />
      </CloseButton>

      <Content>
        <span
          id="notification.card.title"
          className="as-little strong"
          style={{ margin: 0 }}
        >
          <Translate
            msg="notification.card.title"
            variables={{ context: variant }}
          />
        </span>
        <span className="as-little"> - </span>
        <span
          id="notification.card.description"
          className="as-little"
          style={{ margin: "0 1rem 0 0" }}
        >
          <Translate
            msg="notification.card.description"
            variables={{ context: variant }}
          />
        </span>
      </Content>
      <VariantImage
        variantImage={variantImage}
        variantImageIsWide={variantImageIsWide}
      />
    </Card>
  );
};

export default NotificationCard;
